import { Action, ActionType } from "./actionTypes";
import { Dispatch } from "redux";

export const setAssetDetails = (name: string, description: string, price: number, isSold: boolean, count: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_ASSET_DETAILS,
      payload: {
        name,
        description,
        price,
        count,
        isSold
      }
    })
  }
}